'use client';

import { useCallback } from 'react';
import { isLocaleCA } from '@libs/core';
import { useScript } from '../useScript';
import { setRecaptchaValues } from './helpers';

export function useGoogleRecaptchaScore() {
    const recaptchaKeyScore =
        (isLocaleCA()
            ? process.env.NEXT_PUBLIC_ENTERPRISE_RECAPTCHA_KEY_CA
            : process.env.NEXT_PUBLIC_ENTERPRISE_RECAPTCHA_KEY) ?? '';

    const recaptchaSrcScore = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaKeyScore}`;
    const recaptchaStatusScore = useScript(recaptchaSrcScore);

    /**
     * generate invisible recaptcha token and save
     * - action used to track specific user interactions
     */
    const executeRecaptchaScore = useCallback(
        async (action: unknown) => {
            if (recaptchaStatusScore === 'ready') {
                const recaptchaToken =
                    await window.grecaptcha?.enterprise.execute(
                        recaptchaKeyScore,
                        { action }
                    );

                await setRecaptchaValues(recaptchaToken);
            }
        },
        [recaptchaKeyScore, recaptchaStatusScore]
    );

    return {
        recaptchaSrcScore,
        recaptchaStatusScore,
        executeRecaptchaScore,
    };
}
